// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"RT-z","inlineTitle":"ST-z","sponsoredAdsWrapper":"TT-z","marketplaceRecosWrapper":"UT-z"};